<template>
  <div class="member-item">
    <div class="name">
      <div class="player-avatar">
        <img :src="player.player_avatar" @error="playerImgError" alt="" />
      </div>
      <span>{{ player.player_name }}</span>
    </div>
    <div class="hero">
      {{ player.kill_count }}
    </div>
    <div class="kda">
      {{ player.assist_count }}
    </div>
    <div class="offered-rate">
      {{ player.death_count }}
    </div>
    <div class="hit-count">
      {{ player.kast | numFixOne }}{{ player.kast > 0 ? '%' : '' }}
    </div>
    <div class="money">
      {{ player.adr_count | numFixOne }}
    </div>
    <div class="damage-count" :class="{ 'red': player.kill_count - player.death_count > 0, 'green': player.kill_count - player.death_count < 0}">
      {{ player.kill_count - player.death_count > 0 ? '+' : '' }}{{ (player.kill_count - player.death_count) || 0  }}
    </div>
    <div class="damage-taken-count" :class="{ 'red': player.fk_diff - 0 > 0, 'green': player.fk_diff - 0 < 0}">
      {{ player.fk_diff - 0 > 0 ?  '+' : ''}}{{ player.fk_diff || 0}}
    </div>
    <div class="prod" :class="{ 'red': player.rating - 0 > 1, 'green': player.rating - 0 < 1}">
      {{ player.rating || 0.00 }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'LolMemberItem',
  props: {
    player: {
      type: Object
    },
    coverInfo: {
      type: Object
    }
  },
  filters: {
    keepOneDecimalStr (num) {
      const result = Number(num.toString().match(/^\d+(?:\.\d{0,1})?/));
      let s = result.toString();
      let rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length <= rs + 1) {
        s += '0';
      }
      return s;
    },
    numFixOne (num) {
      return (Math.floor((num || 0) * 10) / 10).toFixed(1)
    }
  },
  computed: {
    offeredRate () {
      const rate = parseInt((this.player.offered_rate - 0) * 100)
      return rate < 0 ? 100 : 100 - rate
    },
    propLength () {
      return this.player.prop && this.player.prop.length
    }
  }
}
</script>

<style lang="less" scoped>
.name {
  width: 126px;
  margin-right: 10px;
}
.hero {
  width: 90px;
}
.kda {
  width: 90px;
}
.offered-rate {
  width: 76px;
  margin-right: 15px;
}
.hit-count {
  width: 76px;
  margin-right: 6px;
}
.money {
  width: 76px;
  margin-right: 6px;
}
.damage-count {
  width: 76px;
  margin-right: 6px;
}
.damage-taken-count {
  width: 76px;
  margin-right: 4px;
}
.prod {
  width: 76px;
}
.member-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  text-align: center;
  box-shadow: inset 0px -1px 0px 0px rgba(0,0,0,0.25);
  font-size: 14px;
  background: #fff;
  padding-right: 20px;
  .name {
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
    .player-avatar {
      width: 53px;
      height: 53px;
      display: flex;
      align-items: center;
      border-radius: 5px;
      overflow: hidden;

      img {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        margin: 0 auto;
      }
    }
    span {
      font-size: 14px;
      width: 55px;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 20px;
    }
  }
  .hero {
    display: flex;
    gap: 4px;
    justify-content: center;
    .avatar {
      position: relative;
      img {
        width: 50px;
        height: 50px;
        border-radius: 4px;
        display: block;
      }
      .level {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 17px;
        font-size: 12px;
        text-align: center;
        width: 17px;
        line-height: 17px;
        background: rgba(0,0,0,0.55);
        border-radius: 0px 8px 0px 0px;
        color: #fff;
      }
    }

    .skill-list{
      display: flex;
      flex-direction: column;
      gap: 4px;
      img {
        display: block;
        width: 23px;
        height: 23px;
        border-radius: 1px;
      }
    }
  }
  .kda {
    width: 92px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    div:last-child {
      color: #777;
    }
  }
  .offered-rate {
    width: 64px;
    margin-right: 15px;
  }
  .hit-count {
    width: 67px;
    margin-right: 6px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    div:last-child {
      color: #777;
    }
  }
  .money {
    width: 72px;
    margin-right: 6px;
  }
  .damage-count {
    width: 72px;
    margin-right: 6px;
    &.red {
      color: #D7142B;
    }
    &.green {
      color: #98CB4A;
    }
  }
  .damage-taken-count {
    width: 72px;
    margin-right: 4px;
    &.red {
      color: #D7142B;
    }
    &.green {
      color: #98CB4A;
    }
  }
  .prod {
    &.red {
      color: #D7142B;
    }
    &.green {
      color: #98CB4A;
    }
  }
}
</style>
